"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerspectiveDataLoader = void 0;
const debug_1 = __importDefault(require("debug"));
const mapValues_1 = __importDefault(require("lodash/mapValues"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const dbgate_tools_1 = require("dbgate-tools");
function normalizeLoadedRow(row) {
    return (0, mapValues_1.default)(row, v => (0, dbgate_tools_1.safeJsonParse)(v) || v);
}
function normalizeResult(result) {
    if ((0, isArray_1.default)(result)) {
        return result.map(normalizeLoadedRow);
    }
    if (result.errorMessage) {
        return result;
    }
    return Object.assign(Object.assign({}, result), { errorMessage: 'Unspecified error' });
}
const dbg = (0, debug_1.default)('dbgate:PerspectiveDataLoader');
class PerspectiveDataLoader {
    constructor(apiCall) {
        this.apiCall = apiCall;
    }
    buildSqlCondition(props) {
        const { schemaName, pureName, bindingColumns, bindingValues, dataColumns, orderBy, sqlCondition } = props;
        const conditions = [];
        if (sqlCondition) {
            conditions.push(sqlCondition);
        }
        if ((bindingColumns === null || bindingColumns === void 0 ? void 0 : bindingColumns.length) == 1) {
            conditions.push({
                conditionType: 'in',
                expr: {
                    exprType: 'column',
                    columnName: bindingColumns[0],
                    source: {
                        name: { schemaName, pureName },
                    },
                },
                values: bindingValues.map(x => x[0]),
            });
        }
        return conditions.length > 0
            ? {
                conditionType: 'and',
                conditions,
            }
            : null;
    }
    loadGroupingSqlDb(props) {
        return __awaiter(this, void 0, void 0, function* () {
            const { schemaName, pureName, bindingColumns } = props;
            const bindingColumnExpressions = bindingColumns.map(columnName => ({
                exprType: 'column',
                columnName,
                source: {
                    name: { schemaName, pureName },
                },
            }));
            const select = {
                commandType: 'select',
                from: {
                    name: { schemaName, pureName },
                },
                columns: [
                    {
                        exprType: 'call',
                        func: 'COUNT',
                        args: [
                            {
                                exprType: 'raw',
                                sql: '*',
                            },
                        ],
                        alias: '_perspective_group_size_',
                    },
                    ...bindingColumnExpressions,
                ],
                where: this.buildSqlCondition(props),
            };
            select.groupBy = bindingColumnExpressions;
            if (dbg === null || dbg === void 0 ? void 0 : dbg.enabled) {
                dbg(`LOAD COUNTS, table=${props.pureName}, columns=${bindingColumns === null || bindingColumns === void 0 ? void 0 : bindingColumns.join(',')}`);
            }
            const response = yield this.apiCall('database-connections/sql-select', {
                conid: props.databaseConfig.conid,
                database: props.databaseConfig.database,
                select,
            });
            if (response.errorMessage)
                return response;
            return response.rows.map(row => (Object.assign(Object.assign({}, row), { _perspective_group_size_: parseInt(row._perspective_group_size_) })));
        });
    }
    loadGroupingDocDb(props) {
        return __awaiter(this, void 0, void 0, function* () {
            const { schemaName, pureName, bindingColumns } = props;
            const aggregate = {
                condition: this.buildSqlCondition(props),
                groupByColumns: bindingColumns,
                aggregateColumns: [
                    {
                        alias: 'pergrpsize',
                        aggregateFunction: 'count',
                    },
                ],
            };
            // const aggregate = [
            //   { $match: this.buildMongoCondition(props) },
            //   {
            //     $group: {
            //       _id: _zipObject(
            //         bindingColumns,
            //         bindingColumns.map(col => '$' + col)
            //       ),
            //       count: { $sum: 1 },
            //     },
            //   },
            // ];
            if (dbg === null || dbg === void 0 ? void 0 : dbg.enabled) {
                dbg(`LOAD COUNTS, table=${props.pureName}, columns=${bindingColumns === null || bindingColumns === void 0 ? void 0 : bindingColumns.join(',')}`);
            }
            const response = yield this.apiCall('database-connections/collection-data', {
                conid: props.databaseConfig.conid,
                database: props.databaseConfig.database,
                options: {
                    pureName,
                    aggregate,
                },
            });
            if (response.errorMessage)
                return response;
            return response.rows.map(row => (Object.assign(Object.assign({}, row), { _perspective_group_size_: parseInt(row.pergrpsize) })));
        });
    }
    loadGrouping(props) {
        return __awaiter(this, void 0, void 0, function* () {
            const { engineType } = props;
            switch (engineType) {
                case 'sqldb':
                    return this.loadGroupingSqlDb(props);
                case 'docdb':
                    return this.loadGroupingDocDb(props);
            }
        });
    }
    loadDataSqlDb(props) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const { schemaName, pureName, bindingColumns, bindingValues, dataColumns, orderBy, sqlCondition: condition, engineType, } = props;
            if ((dataColumns === null || dataColumns === void 0 ? void 0 : dataColumns.length) == 0) {
                return [];
            }
            const select = {
                commandType: 'select',
                from: {
                    name: { schemaName, pureName },
                },
                columns: dataColumns === null || dataColumns === void 0 ? void 0 : dataColumns.map(columnName => ({
                    exprType: 'column',
                    columnName,
                    source: {
                        name: { schemaName, pureName },
                    },
                })),
                selectAll: !dataColumns,
                orderBy: (orderBy === null || orderBy === void 0 ? void 0 : orderBy.length) > 0
                    ? orderBy === null || orderBy === void 0 ? void 0 : orderBy.map(({ columnName, order }) => ({
                        exprType: 'column',
                        columnName,
                        direction: order,
                        source: {
                            name: { schemaName, pureName },
                        },
                    }))
                    : null,
                range: props.range,
                where: this.buildSqlCondition(props),
            };
            if (dbg === null || dbg === void 0 ? void 0 : dbg.enabled) {
                dbg(`LOAD DATA, table=${props.pureName}, columns=${(_a = props.dataColumns) === null || _a === void 0 ? void 0 : _a.join(',')}, range=${(_b = props.range) === null || _b === void 0 ? void 0 : _b.offset},${(_c = props.range) === null || _c === void 0 ? void 0 : _c.limit}`);
            }
            const response = yield this.apiCall('database-connections/sql-select', {
                conid: props.databaseConfig.conid,
                database: props.databaseConfig.database,
                select,
            });
            if (response.errorMessage)
                return response;
            return response.rows;
        });
    }
    getDocDbLoadOptions(props, useSort) {
        var _a, _b, _c;
        const { pureName } = props;
        const res = {
            pureName,
            condition: this.buildSqlCondition(props),
            sort: useSort && ((_a = props.orderBy) === null || _a === void 0 ? void 0 : _a.length) > 0
                ? props.orderBy.map(x => (Object.assign(Object.assign({}, x), { direction: x.order })))
                : undefined,
            skip: (_b = props.range) === null || _b === void 0 ? void 0 : _b.offset,
            limit: (_c = props.range) === null || _c === void 0 ? void 0 : _c.limit,
        };
        // if (useSort && props.orderBy?.length > 0) {
        //   res.sort = _zipObject(
        //     props.orderBy.map(col => col.columnName),
        //     props.orderBy.map(col => (col.order == 'DESC' ? -1 : 1))
        //   );
        // }
        return res;
    }
    loadDataDocDb(props) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const { schemaName, pureName, bindingColumns, bindingValues, dataColumns, orderBy, sqlCondition: condition, engineType, } = props;
            if (dbg === null || dbg === void 0 ? void 0 : dbg.enabled) {
                dbg(`LOAD DATA, collection=${props.pureName}, columns=${(_a = props.dataColumns) === null || _a === void 0 ? void 0 : _a.join(',')}, range=${(_b = props.range) === null || _b === void 0 ? void 0 : _b.offset},${(_c = props.range) === null || _c === void 0 ? void 0 : _c.limit}`);
            }
            const options = this.getDocDbLoadOptions(props, true);
            const response = yield this.apiCall('database-connections/collection-data', {
                conid: props.databaseConfig.conid,
                database: props.databaseConfig.database,
                options,
            });
            if (response.errorMessage)
                return response;
            return response.rows;
        });
    }
    loadData(props) {
        return __awaiter(this, void 0, void 0, function* () {
            const { engineType } = props;
            switch (engineType) {
                case 'sqldb':
                    return normalizeResult(yield this.loadDataSqlDb(props));
                case 'docdb':
                    return normalizeResult(yield this.loadDataDocDb(props));
            }
        });
    }
    loadRowCountSqlDb(props) {
        return __awaiter(this, void 0, void 0, function* () {
            const { schemaName, pureName, bindingColumns, bindingValues, dataColumns, orderBy, sqlCondition: condition, } = props;
            const select = {
                commandType: 'select',
                from: {
                    name: { schemaName, pureName },
                },
                columns: [
                    {
                        exprType: 'raw',
                        sql: 'COUNT(*)',
                        alias: 'count',
                    },
                ],
                where: this.buildSqlCondition(props),
            };
            const response = yield this.apiCall('database-connections/sql-select', {
                conid: props.databaseConfig.conid,
                database: props.databaseConfig.database,
                select,
            });
            if (response.errorMessage)
                return response;
            return response.rows[0];
        });
    }
    loadRowCountDocDb(props) {
        return __awaiter(this, void 0, void 0, function* () {
            const { schemaName, pureName, bindingColumns, bindingValues, dataColumns, orderBy, sqlCondition: condition, } = props;
            const options = Object.assign(Object.assign({}, this.getDocDbLoadOptions(props, false)), { countDocuments: true });
            const response = yield this.apiCall('database-connections/collection-data', {
                conid: props.databaseConfig.conid,
                database: props.databaseConfig.database,
                options,
            });
            return response;
        });
    }
    loadRowCount(props) {
        return __awaiter(this, void 0, void 0, function* () {
            const { engineType } = props;
            switch (engineType) {
                case 'sqldb':
                    return this.loadRowCountSqlDb(props);
                case 'docdb':
                    return this.loadRowCountDocDb(props);
            }
        });
    }
}
exports.PerspectiveDataLoader = PerspectiveDataLoader;
